import React, { PropsWithChildren } from 'react';
import { Flex } from '@chakra-ui/react';
import { Navbar } from '@/src/app/_components/navigation/navbar/Navbar';

export const EmptyPageWithLogo: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Flex h={'full'} w={'full'} flexDirection={'column'}>
      <Flex w={'full'} borderBottom={'1px solid'} borderColor={'lc.system.neutral.30'}>
        <Navbar />
      </Flex>
      <Flex h={'full'} w={'full'} justifyContent={'center'} pt={12}>
        {children}
      </Flex>
    </Flex>
  );
};
